// Unit Size options: unit price rendering, quantity labels, and savings tags (no console logs)

async function emptyLinkedOptionsPrices() {
  const unitSizeBox = document.querySelector('.lv-option-box[data-option-name="Unit Size"]');
  if (!unitSizeBox) return;

  const priceElements = unitSizeBox.querySelectorAll('.lv-option-price.lv-option-amount');
  const optionData = [];

  for (const element of priceElements) {
    try {
      const unitPriceHTML = await getUnitPriceForElement(element);
      if (unitPriceHTML) {
        element.innerHTML = unitPriceHTML;
        element.style.visibility = 'visible';

        const unitPriceElement = element.querySelector('.unit-price');
        if (unitPriceElement) {
          unitPriceElement.style.opacity = '0';
          unitPriceElement.style.transition = 'opacity 0.3s ease-in-out';
          setTimeout(() => { unitPriceElement.style.opacity = '1'; }, 50);
        }

        const optionInfo = await getOptionInfo(element);
        if (optionInfo && optionInfo.unitPrice && !isNaN(optionInfo.unitPrice)) {
          optionData.push(optionInfo);
        }
      }
    } catch (_) {}
  }

  await addSavingsTags(optionData);
  await addUnitQuantities();
}

async function getUnitPriceForElement(priceElement) {
  const optionWrapper = priceElement.closest('.lv-option-wrapper');
  if (!optionWrapper) return null;

  const optionItem = optionWrapper.querySelector('.lv-option-item');
  if (!optionItem) return null;

  const isActive = optionItem.classList.contains('lv-option-item__active');
  if (isActive) {
    return getCurrentPageUnitPrice();
  } else {
    const productInfo = getProductInfoFromOption(optionItem);
    if (productInfo) {
      const optionLabel = optionItem.getAttribute('title') || optionItem.getAttribute('data-value') || '';
      return await fetchUnitPriceFromSection(productInfo, optionLabel);
    }
    return null;
  }
}

function getCurrentPageUnitPrice() {
  const selectors = [
    '.product-info .unit-price',
    '.unit-price',
    '.price .unit-price',
    '.product-price .unit-price'
  ];

  for (const selector of selectors) {
    const unitPriceElement = document.querySelector(selector);
    if (unitPriceElement) return unitPriceElement.outerHTML;
  }
  // Fallback: compute unit price from current price and metafields
  const priceCurrentEl = document.querySelector('.price__current');
  const metafieldsScript = document.querySelector('script[id^="product-metafields-"]');
  if (!priceCurrentEl || !metafieldsScript) return null;
  try {
    const priceText = priceCurrentEl.textContent.trim();
    const currentPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    const metafields = JSON.parse(metafieldsScript.textContent);
    const unitSize = parseInt(metafields.unit_size);
    const unitName = metafields.unit_name;
    if (!currentPrice || !unitSize || !unitName) return null;
    const unitPriceValue = currentPrice / unitSize;
    const formatted = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(unitPriceValue);
    return `<div class="unit-price relative"><span class="visually-hidden">Unit price</span><span class="unit-price__price">${formatted}</span><span class="unit-price__separator"> / </span><span class="unit-price__unit">${unitName}</span></div>`;
  } catch (_) {
    return null;
  }
}

function getProductInfoFromOption(optionItem) {
  let linkElement = null;
  if (optionItem.tagName === 'A' && optionItem.href) {
    linkElement = optionItem;
  } else {
    linkElement = optionItem.querySelector('a[href]');
  }
  if (!linkElement || !linkElement.href) return null;

  const url = new URL(linkElement.href);
  const pathParts = url.pathname.split('/');
  const productHandle = pathParts[pathParts.length - 1];
  const variantId = url.searchParams.get('variant');

  return { handle: productHandle, variantId, url: url.toString() };
}

// Fetch a section's HTML using the Section Rendering API with sections + sections_url
async function fetchSectionHtml(productInfo, sectionKey = 'main-product') {
  try {
    const sectionsUrl = new URL(window.location.origin + '/');
    sectionsUrl.searchParams.set('sections', sectionKey);
    const urlPath = new URL(productInfo.url, window.location.origin).pathname;
    sectionsUrl.searchParams.set('sections_url', urlPath);
    const resp = await fetch(sectionsUrl.toString());
    if (!resp.ok) return null;
    const json = await resp.json();
    if (json && typeof json[sectionKey] === 'string') return json[sectionKey];
    if (json && typeof json === 'object') {
      for (const key in json) {
        if (typeof json[key] === 'string') return json[key];
      }
    }
    return null;
  } catch (_) {
    return null;
  }
}

async function fetchUnitPriceFromSection(productInfo, optionLabel = null) {
  try {
    // 1) Prefer Sections Rendering API (no hard-coded section_id)
    const sectionHtml = await fetchSectionHtml(productInfo, 'main-product');
    if (sectionHtml) {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const unitPriceEl = doc.querySelector('.unit-price');
      if (unitPriceEl) return unitPriceEl.outerHTML;
    }

    // 2) Fallback: fetch full product page HTML and parse
    const response = await fetch(productInfo.url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const responseText = await response.text();
    const doc = new DOMParser().parseFromString(responseText, 'text/html');
    const unitPriceElement = doc.querySelector('.unit-price');
    if (unitPriceElement) return unitPriceElement.outerHTML;
    // Fallback: compute from price and metafields on fetched page
    const priceCurrentEl = doc.querySelector('.price__current');
    const metafieldsScript = doc.querySelector('script[id^="product-metafields-"]');
    if (!priceCurrentEl || !metafieldsScript) return null;
    const priceText = priceCurrentEl.textContent.trim();
    const currentPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    const metafields = JSON.parse(metafieldsScript.textContent);
    let unitSize = parseInt(metafields.unit_size);
    const unitName = metafields.unit_name;
    if (!currentPrice || !unitName) return null;
    if (!unitSize || isNaN(unitSize)) {
      const qtyLabel = await getQuantityFromProduct(productInfo, optionLabel);
      const match = qtyLabel && qtyLabel.match(/([\d,]+)/);
      if (match) unitSize = parseInt(match[1].replace(/,/g, ''));
    }
    if (!unitSize || isNaN(unitSize) || unitSize === 0) return null;
    const unitPriceValue = currentPrice / unitSize;
    const formatted = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(unitPriceValue);
    return `<div class="unit-price relative"><span class="visually-hidden">Unit price</span><span class="unit-price__price">${formatted}</span><span class="unit-price__separator"> / </span><span class="unit-price__unit">${unitName}</span></div>`;
  } catch (_) {
    return null;
  }
}

async function getOptionInfo(priceElement) {
  try {
    const optionWrapper = priceElement.closest('.lv-option-wrapper');
    if (!optionWrapper) return null;

    const optionItem = optionWrapper.querySelector('.lv-option-item');
    if (!optionItem) return null;

    const optionName = optionItem.getAttribute('title') || optionItem.getAttribute('data-value') || '';
    const unitPriceSpan = priceElement.querySelector('.unit-price__price');
    if (!unitPriceSpan) return null;

    const priceText = unitPriceSpan.textContent.trim();
    const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));

    let optionType = 'pack';
    const nameLower = optionName.toLowerCase();
    if (nameLower.includes('case') || nameLower.includes('bulk')) {
      optionType = 'case';
    } else if (nameLower.includes('pallet')) {
      optionType = 'pallet';
    }

    return {
      element: priceElement,
      optionWrapper,
      optionItem,
      optionName,
      optionType,
      unitPrice: priceValue,
      isActive: optionItem.classList.contains('lv-option-item__active')
    };
  } catch (_) {
    return null;
  }
}

async function addSavingsTags(optionData) {
  if (optionData.length === 0) return;
  const packOption = optionData.find(option => option.optionType === 'pack');
  if (!packOption) return;

  optionData.forEach(option => {
    if (option.optionType === 'case' || option.optionType === 'pallet') {
      if (packOption.unitPrice > 0 && option.unitPrice > 0) {
        const savings = ((packOption.unitPrice - option.unitPrice) / packOption.unitPrice) * 100;
        if (savings > 0) createSavingsTag(option, savings);
      }
    }
  });
}

function createSavingsTag(optionInfo, savingsPercent) {
  const existingTag = optionInfo.optionWrapper.querySelector('.savings-tag');
  if (existingTag) existingTag.remove();

  const savingsTag = document.createElement('div');
  savingsTag.className = 'savings-tag';
  savingsTag.textContent = `Save ${savingsPercent.toFixed(0)}%`;
  savingsTag.style.cssText = `
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    background: #ff6b35;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;
    z-index: 10;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
  `;

  if (getComputedStyle(optionInfo.optionWrapper).position === 'static') {
    optionInfo.optionWrapper.style.position = 'relative';
  }
  optionInfo.optionWrapper.appendChild(savingsTag);
  setTimeout(() => { savingsTag.style.opacity = '1'; }, 100);
}

async function addUnitQuantities() {
  const unitSizeBox = document.querySelector('.lv-option-box[data-option-name="Unit Size"]');
  if (!unitSizeBox) return;

  const optionItems = unitSizeBox.querySelectorAll('.lv-option-item');
  for (const optionItem of optionItems) {
    try {
      const optionNameElement = optionItem.querySelector('.lv-option-name');
      if (!optionNameElement) continue;

      const originalName = optionNameElement.textContent.trim();
      const baseLabel = originalName.toLowerCase().includes(' of ')
        ? originalName.split(/\s+of\s+/i)[0].trim()
        : originalName;
      const optionLabel = optionItem.getAttribute('title') || optionItem.getAttribute('data-value') || baseLabel;

      let quantity = null;
      if (optionItem.classList.contains('lv-option-item__active')) {
        quantity = getCurrentPageQuantity(optionLabel);
      } else {
        const productInfo = getProductInfoFromOption(optionItem);
        if (productInfo) quantity = await getQuantityFromProduct(productInfo, optionLabel);
      }

      if (quantity) {
        const numberMatch = quantity.match(/([\d,]+)/);
        const actualQuantity = numberMatch ? numberMatch[1] : quantity;
        optionNameElement.textContent = `${baseLabel} of ${actualQuantity}`;
      }
    } catch (_) {}
  }
}

function getCurrentPageQuantity(optionLabel = null) {
  const metafieldsScript = document.querySelector('script[id^="product-metafields-"]');
  if (metafieldsScript) {
    try {
      const metafields = JSON.parse(metafieldsScript.textContent);
      if (metafields.unit_size && metafields.unit_name) {
        return formatQuantityString(metafields.unit_size, metafields.unit_name, metafields, optionLabel);
      }
    } catch (_) {}
  }

  const customLabel = document.querySelector('.product-label.product-label--custom');
  if (customLabel) return customLabel.textContent.trim();

  const currentTitle = document.title || '';
  if (currentTitle.toLowerCase().includes('case') || currentTitle.toLowerCase().includes('bulk')) return '500';
  if (currentTitle.toLowerCase().includes('pallet')) return '48,000';
  return '25';
}

function formatQuantityString(unitSize, unitName, metafields = null, optionLabel = null) {
  let finalQuantity = parseInt(unitSize);
  let optionType = 'Pack';

  const labelLower = String(optionLabel || '').toLowerCase();
  if (labelLower.includes('case')) {
    optionType = 'Case';
    if (metafields && metafields.case_quantity && parseInt(metafields.case_quantity) > 1) {
      finalQuantity = parseInt(unitSize) * parseInt(metafields.case_quantity);
    }
  } else if (labelLower.includes('pallet')) {
    optionType = 'Pallet';
    if (metafields && metafields.pallet_quantity && parseInt(metafields.pallet_quantity) > 0) {
      finalQuantity = parseInt(metafields.pallet_quantity);
    }
  } else {
    if (parseInt(unitSize) >= 48000) {
      optionType = 'Pallet';
    } else {
      optionType = 'Pack';
    }
  }

  const formattedSize = finalQuantity.toLocaleString();
  return `${optionType} of ${formattedSize}`;
}

async function getQuantityFromProduct(productInfo, optionLabel = null) {
  try {
    // 1) Prefer Sections Rendering API
    const sectionHtml = await fetchSectionHtml(productInfo, 'main-product');
    if (sectionHtml) {
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const metafieldsScript = doc.querySelector('script[id^="product-metafields-"]');
      if (metafieldsScript) {
        try {
          const metafields = JSON.parse(metafieldsScript.textContent);
          if (metafields.unit_size && metafields.unit_name) {
            return formatQuantityString(metafields.unit_size, metafields.unit_name, metafields, optionLabel);
          }
        } catch (_) {}
      }
      const customLabel = doc.querySelector('.product-label.product-label--custom');
      if (customLabel) return customLabel.textContent.trim();
    }

    // 2) Fallback: full page fetch
    const response = await fetch(productInfo.url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const responseText = await response.text();
    const doc = new DOMParser().parseFromString(responseText, 'text/html');
    const metafieldsScript = doc.querySelector('script[id^="product-metafields-"]');
    if (metafieldsScript) {
      try {
        const metafields = JSON.parse(metafieldsScript.textContent);
        if (metafields.unit_size && metafields.unit_name) {
          return formatQuantityString(metafields.unit_size, metafields.unit_name, metafields, optionLabel);
        }
      } catch (_) {}
    }

    const customLabel = doc.querySelector('.product-label.product-label--custom');
    if (customLabel) return customLabel.textContent.trim();

    const handle = productInfo.handle.toLowerCase();
    if (handle.includes('case') || handle.includes('bulk')) return '500';
    if (handle.includes('pallet')) return '48,000';
    return '25';
  } catch (_) {
    const url = productInfo.url.toLowerCase();
    if (url.includes('case') || url.includes('bulk')) return '500';
    if (url.includes('pallet')) return '48,000';
    return '25';
  }
}

document.addEventListener('DOMContentLoaded', emptyLinkedOptionsPrices);
document.addEventListener('shopify:section:load', emptyLinkedOptionsPrices);

if (window.MutationObserver) {
  const observer = new MutationObserver(async (mutations) => {
    const elementsToProcess = [];
    const unitSizeBox = document.querySelector('.lv-option-box[data-option-name="Unit Size"]');
    if (!unitSizeBox) return;

    mutations.forEach((mutation) => {
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (unitSizeBox.contains(node) || node.contains(unitSizeBox)) {
              if (node.classList && node.classList.contains('lv-option-price') && node.classList.contains('lv-option-amount')) {
                elementsToProcess.push(node);
              }
              const targetElements = node.querySelectorAll && node.querySelectorAll('.lv-option-price.lv-option-amount');
              if (targetElements) {
                targetElements.forEach((element) => {
                  if (unitSizeBox.contains(element)) elementsToProcess.push(element);
                });
              }
            }
          }
        });
      }
    });

    for (const element of elementsToProcess) {
      try {
        const unitPriceHTML = await getUnitPriceForElement(element);
        if (unitPriceHTML) {
          element.innerHTML = unitPriceHTML;
          element.style.visibility = 'visible';
        }
      } catch (_) {}
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
}


